import { render, staticRenderFns } from "./modalFormHeader.vue?vue&type=template&id=3d38150c&"
import script from "./modalFormHeader.vue?vue&type=script&lang=js&"
export * from "./modalFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./modalFormHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports